<div class="layout-container">
  
  <!-- BACKDROP MOBILE -->
  <div class="sidebar-backdrop" 
       [class.visible]="isSidebarOpen()" 
       (click)="toggleSidebar()">
  </div>

  <!-- SIDEBAR IZQUIERDO -->
  <app-sidebar
    [class.sidebar-mobile-open]="isSidebarOpen()"
    [class.sidebar-collapsed]="isSidebarCollapsed()"
    [collapsed]="isSidebarCollapsed()"
    (toggleCollapsed)="toggleSidebarCollapsed()">
  </app-sidebar>

  <!-- CONTENIDO PRINCIPAL -->
  <div class="main-wrapper">
    
    <!-- MOBILE HEADER -->
    <header class="mobile-header">
      <button class="menu-btn" (click)="toggleSidebar()">
        <mat-icon>menu</mat-icon>
      </button>
      <span class="mobile-brand">BRO Admin</span>
    </header>

    <main class="content">
      <router-outlet></router-outlet>
    </main>

    <footer>
      <app-footer></app-footer>
    </footer>
  </div>

</div>
